import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable()
export class Settings {
    public servicePayloadDetails: any;
    public serviceUrl: string = "";//https://localhost:44340/  //http://usilg01-ist111:64613/ 
    public redirectUrl: string = ""; //<-- for Local, For Test --> http://usilg01-ist109:65006/
    public configId: string = "SIT";
    public agentPortalUrl: string = "https://apps-test.berkleymarine.com/BFMAgent.Web/Policy#qsearchpolicy/";
    public documentCenterUrl: string = "https://apps-test.berkleymarine.com/BFMAgent.Web/";
    public apiBaseUrl: string = "";
    public unauthenticatedUrl: string = "/xps/unauthenticated";
    public unauthorizedRedirect: string = "/unauthorized";
    public quickQuotePolicyUrl: string = "";
    public sitsUrl: string = "http://clientdashboardapi-sits.wrbts.ads.wrberkley.com/";
    public AuthApiUrl: string = "";
    public configDatas = [];
    constructor() {

        this.configDatas = [
            { env: "local", serviceUrl: "https://tst-gateway.berkley-bts.com/026/sits/xpressservice/", redirectUrl: "http://localhost:4200/xps/landing/", documentCenterUrl: "https://apps-test.berkleymarine.com/BFMAgent.Web/", agentPortalUrl: "https://apps-test.berkleymarine.com/BFMAgent.Web/Policy#qsearchpolicy/", sitsUrl: "http://clientdashboardapi-sits.wrbts.ads.wrberkley.com/" ,quickQuotePolicyUrl: "https://tst-xp.berkleymarine.com/QuickQuote/"},
            { env: "int", serviceUrl: "https://USILG01-ISI033:64613/", redirectUrl: "https://int-xp.berkleymarine.com/xps/landing/", documentCenterUrl: "https://apps-test.berkleymarine.com/BFMAgent.Web/", agentPortalUrl: "https://apps-test.berkleymarine.com/BFMAgent.Web/Policy#qsearchpolicy/", sitsUrl: "http://clientdashboardapi-sits.wrbts.ads.wrberkley.com/" ,quickQuotePolicyUrl: "https://tst-xp.berkleymarine.com/QuickQuote/"},
            { env: "testing", serviceUrl: "https://tst-gateway.berkley-bts.com/026/sits/xpressservice/", redirectUrl: "https://tst-xp.berkleymarine.com/xps/landing/", documentCenterUrl: "https://apps-test.berkleymarine.com/BFMAgent.Web/", agentPortalUrl: "https://apps-test.berkleymarine.com/BFMAgent.Web/Policy#qsearchpolicy/", sitsUrl: "http://clientdashboardapi-sits.wrbts.ads.wrberkley.com/",quickQuotePolicyUrl: "https://tst-xp.berkleymarine.com/QuickQuote/"},
            { env: "prod", serviceUrl: "https://gateway.wrberkley.com/026/sits/xpressservice/", redirectUrl: "https://xp.berkleymarine.com/xps/landing/", documentCenterUrl: "https://agentportal.berkleymarine.com/", agentPortalUrl: "https://agentportal.berkleymarine.com/Policy#qsearchpolicy/", sitsUrl: "http://clientdashboardapi-sits.wrbts.ads.wrberkley.com/" ,quickQuotePolicyUrl: "https://xp.berkleymarine.com/QuickQuote/"}
        ]

        this.getConfig(environment.config);
    }
    getConfig(env) {
        let config = this.configDatas.filter(c => c.env == env)[0];
        this.serviceUrl = config.serviceUrl;
        this.redirectUrl = config.redirectUrl;
        this.sitsUrl = config.sitsUrl;
        this.agentPortalUrl = config.agentPortalUrl;
        this.documentCenterUrl = config.documentCenterUrl;
        this.quickQuotePolicyUrl = config.quickQuotePolicyUrl;
        this.AuthApiUrl = environment.AuthApiURL;
    }
    initializeCommonData() {
        return this.servicePayloadDetails = [
            { 
                componentName: "BearerToken",
                functionality: "GetBearerTokenForAPIAuthentication",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.AuthApiUrl + "bearer/token/by/application/{0}/company/{1}",
                    method: "GET"
                }
            },
            { 
                componentName: "policyTab",
                functionality: "policydetail",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/by/company/{0}/number/{1}/term/{2}",
                    method: "GET"
                }
            },
            {
                componentName: "policyTab",
                functionality: "cancelReasons",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/cancellation/questionnaire/by/company/{0}",
                    method: "GET"
                }
            },
            {
                componentName: "cancelReasons",
                functionality: "submitCancelDetail",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "cancel/policy/for/company/{0}/IsClaimFound/{1}/IsPendingAmendment/{2}/rateOnly/{3}/referenceNumber/{4}/productCode/{6}/policyNo/{5}/insuredName/{7}/userEmail/{8}/totalPremium/{9}/mod/{10}",
                    method: "PUT"
                }
            },
            {
                componentName: "client",
                functionality: "SITUserVerification",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.sitsUrl + "is/sitsuser/email/{0}",
                    method: "GET"
                }
            }, {
                componentName: "policies",
                functionality: "searchPoliciesGrid",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policies/By/email/{0}/isInternal/{1}/agencyCodes/{2}",
                    method: "GET"
                }
            }, {
                componentName: "policies",
                functionality: "openQuickQuoteLink",
                endPointInfo: {
                    endPointUrl: this.quickQuotePolicyUrl + "QuickQuote/RetrieveQuote?companyCode={0}&productCode={1}&referenceNumber={2}",
                    method: "GET"
                }
            }, {
                componentName: "policyTab",
                functionality: "getPolicyDetails",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/By/{0}/{1}",
                    method: "GET"
                }
            }, {
                componentName: "policies",
                functionality: "FiltersearchPoliciesGrid",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policies/By/email/{0}/searchCriterias/{1}/status/{2}/",
                    method: "GET"
                }
            },
            {
                componentName: "landing",
                functionality: "underwriterInfo",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "landingPage/{0}",
                    method: "GET"
                }
            },           
            {
                componentName: "ManagePolicy",
                functionality: "PolicyRequestLabel",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "amendmentScreenLabels",
                    method: "GET"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "PolicyQuestionnaire",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/amendment/questionnaire/by/company/{0}/amendType/{1}",
                    method: "GET"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "PolicyDetails",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/by/company/{0}/number/{1}/term/{2}",
                    method: "GET"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "DeclineOption",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "PolicyExtension/By/companyCode/{0}/isAllowed/{1}/policyNumber/{2}/amendType/{3}/productCode/{4}",
                    method: "POST"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "SubmitPremium",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "amendpolicy/company/{0}/rateOnly/{1}/referenceNumber/{2}/policyNumber/{3}/IsClaimFound/{4}/IsPendingAmendment/{5}/productCode/{6}/policyEffectiveDate/{7}/policyExpirationDate/{8}/insuredName/{9}/userEmail/{10}/amendCount/{11}/mod/{12}",
                    method: "PUT"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "PolicyDenied",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "PolicyDenied/company/{0}/rateOnly/{1}/referenceNumber/{2}/policyNumber/{3}/IsClaimFound/{4}/IsPendingAmendment/{5}/productCode/{6}/policyEffectiveDate/{7}/policyExpirationDate/{8}/insuredName/{9}/userEmail/{10}/amendCount/{11}/mod/{12}",
                    method: "PUT"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "getBPMiFields",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "get/bpmiFields/by/policyNumber/{0}",
                    method: "GET"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "getPolicyDetails",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/By/v1/companyCode/{0}/policyNumber/{1}",
                    method: "GET"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "GetCoverageQuestionnaire",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/amendment/questionnaire/by/company/{0}/amendType/{1}",
                    method: "GET"
                }
            },
            {
                componentName: "ManagePolicy",
                functionality: "GetPolicyLimits",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policy/company/{0}/jobSiteLimit/{1}/currentDeductibleValue/{2}/currentFloodValue/{3}/currentEQValue/{4}",
                    method: "GET"
                }
            },
            {
                componentName: "EvidenceInsurance",
                functionality: "RequestEvidence",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "save/evidence/of/insurance/userName/{0}/insuredName/{1}/policyNumber/{2}/companyCode/{3}/productCode/{4}/referenceNumber/{5}",
                    method: "POST"
                }
            },
            {
                componentName: "EvidenceInsurance",
                functionality: "GetEvidencePDF",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "download/evidence/pdf",
                    method: "POST"
                }
            },
            {
                componentName: "Link",
                functionality: "agentPortal",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.agentPortalUrl + "policy/{0}",
                    method: "GET"
                }
            },
            {
                componentName: "Link",
                functionality: "documentCenter",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.documentCenterUrl,
                    method: "GET"
                }
            },
            {
                componentName: "Landing",
                functionality: "GetExternal",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "get/externalUser/{0}/",
                    method: "GET"
                }
            },
            {
                componentName: "Landing",
                functionality: "GetEvents",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "getevents/{0}/",
                    method: "GET"
                }
            }, 
            {
                componentName: "Landing",
                functionality: "GetCountyByStateCode",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "GetCountyByStateCode/{0}/",
                    method: "GET"
                }
            },        
            {
                componentName: "ReportClaim",
                functionality: "SubmitReportClaim",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "submit/reportClaim",
                    method: "POST"
                }
            },
            {
                componentName: "upload",
                functionality: "FileUpload",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "osc/fileupload/{0}/{1}",
                    method: "POST"
                }
            }
            ,
            {
                componentName: "reportClaim",
                functionality: "getDropdowns",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "get/reportClaim/types",
                    method: "GET"
                }
            },
            {
                componentName: "reportClaim",
                functionality: "sendMail",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "send/reportClaim/confirmationEmail/{0}/{1}/{2}/{3}",
                    method: "POST"
                }
            },
            {
                componentName: "Common",
                functionality: "PostUserActivity",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "save/userActivity/",
                    method: "POST"
                }
            },
            {
                componentName: "policies",
                functionality: "PoliciesBasedOnSearch",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "policies/By/email/{0}/policyOrNameInsured/{1}",
                    method: "GET"
                }
            },
            {
                componentName: "policies",
                functionality: "ViewPolicyDocumentError",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "error/on/policy/document",
                    method: "POST"
                } 
            },
            {
                componentName: "Landing",
                functionality: "GetNotifications",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "GetNotifications/ApplicationCode/{0}/Environment/{1}/TimeZoneId/{2}",
                    method: "GET"
                }
            },
            {
                componentName: "User",
                functionality: "InternalBFMUser",
                Header: "",
                endPointInfo: {
                    endPointUrl: this.serviceUrl + "get/InternalBFMUser/{0}",
                    method: "GET"
                }
            }
        ]
    }

    getServicePayloadDetails(componentName, functionality, payload) {       
        let result = this.initializeCommonData().filter(data => data.componentName == componentName && data.functionality == functionality);
        //=====set value into url for GET call
        if (result != null && result.length > 0 && (result[0].endPointInfo.method == "GET" || result[0].endPointInfo.method == "PUT" || result[0].endPointInfo.method == "POST") && payload != null && payload.length) {
            payload.forEach((data, index) => {
                result[0].endPointInfo.endPointUrl = result[0].endPointInfo.endPointUrl.replace("{" + index + "}", data);
            })
        }
        return (result != null && result.length > 0) ? result[0] : null;
    }

}
